export const isNewPageCardExtraInfoEnabled = () =>
    window?.enabledFeatures?.isNewPageCardExtraInfo === 'True' || false;

export const isNewNewsletterEnabled = () => window?.enabledFeatures?.isNewNewsletterEnabled === 'True' || false;
export const isUpsellEnabled = () => window?.enabledFeatures?.isUpsellEnabled === 'True' || false;
export const isNewFilterEnabled = () => window?.enabledFeatures?.isNewFilterEnabled === 'True' || false;

export default {
    isNewPageCardExtraInfoEnabled,
    isNewNewsletterEnabled,
    isUpsellEnabled,
    isNewFilterEnabled,
};
